const NewsDetail = () => import("@/components/news_layout/NewsDetail");
const AboutNews = () => import("@/screens/about/AboutNews");
const AboutBranch = () => import("@/screens/about/AboutBranch");
const OurService = () => import("@/screens/our_service/OurService");
const AboutMain = () => import("@/screens/about/AboutMain");
const AboutMiniTcdc = () => import("@/screens/about/AboutMiniTcdc");

export const aboutRouter = [
    {
        path: "about-main",
        name: "AboutMain",
        component: AboutMain,
    },
    {
        path: ":branch/about/news/:id",
        name: "NewsDetail",
        component: NewsDetail,
    },
    {
        path: ":branch/about/news",
        name: "AboutNews",
        component: AboutNews,
    },
    {
        path: ":branch/about",
        name: "AboutBranch",
        component: AboutBranch,
    },
    {
        path: "our-service",
        name: "OurService",
        component: OurService,
        redirect: to => `/${to.params.lang}/home`,
    },
    {
        path: ":branch/about/mini-tcdc",
        name: "AboutMiniTcdc",
        component: AboutMiniTcdc,
    },
]